import { ActivityStatus, AudienceTargetingSegment } from '@/app/shared/_models/models';

import { UniversalMediaListSegmentType, UniversalMediaListType } from './universal-media-list-types.model';

export interface UniversalMediaList {
  id: number;
  name: string;
  notes: string;
  createdAt: Date;
  updatedAt: Date;
  mediaType: UniversalMediaListSegmentType;
  listType: UniversalMediaListType;
  accountId: number;
  status: ActivityStatus;
  dealCount: number;
  segment?: AudienceTargetingSegment;
}

export interface UniversalMediaListDomainUpdatePayload {
  domainsToAdd?: string[];
  domainsToRemove?: string[];
  removeAll?: boolean;
}

export interface UniversalMediaListAssociatedDealsRemovalPayload {
  dealIds?: number[];
  removeAll?: boolean;
}

export enum SelectionStatus {
  SELECTED = 'selected',
  DISABLED = 'disabled'
}
